// import FilterRow, {
//   FilterRowProps,
// } from "@/components/UtilitiesComponent/FilterRow";
import assest from "../../../../json/assest";
import React from "react";
import styles from "../../../../styles/pages/home.module.scss";
// import styles1 from "@/styles/components/dashboardTable.module.scss";
import styles1 from "../../../../styles/components/dashboardTable.module.scss";
import {
  Box,
  Button,
  Dialog,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import Pagination from "@/components/UtilitiesComponent/Pagination";
// import AllPurchasedFilterModal from "@/components/FilterModal/AllPurchasedFilterModal";
import { Link, useLocation } from "react-router-dom";
// import DisplayRelease from "@/components/DisplayRelease/DisplayRelease";
import FilterRow from "../../../UtilitiesComponent/FilterRow";
import Pagination from "../../../UtilitiesComponent/Pagination";
import DisplayRelease from "../../../DisplayRelease/DisplayRelease";
import AllPurchasedFilterModal from "../../../FilterModal/AllPurchasedFilterModal";

function createData(
  VSID,
  Buyer,
  Thumbnail,
  Title,
  Owner,
  Email,
  Purchase,
  Approved
) {
  return { VSID, Buyer, Thumbnail, Title, Owner, Email, Purchase, Approved };
}

const rows = [
  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail1} width={73} height={46} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail2} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail3} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail4} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail5} width={73} height={46} alt="" />
    </>,
    "Girl Tries Hitting a Car with Her Hand at a Traffic Light",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail6} width={73} height={46} alt="" />
    </>,
    "Girl Gets Surprised with a Baby Yoda Toy That She Wanted for So Long",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail7} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail8} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail9} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail10} width={73} height={46} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail11} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail12} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail13} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail14} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail15} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail16} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail17} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail18} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail19} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
];

// type SingleTableContainerProps = {
//   hideApprovedTab?: boolean;
//   approvedTabName?: string;
//   filterRowProps? ;
// };
export default function SingleTableContainer(props) {
  const { hideApprovedTab, approvedTabName, filterRowProps } = props;
  // const route = useRouter();
  let { pathname } = useLocation();

  // for modal

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  // for modal

  return (
    <Box className={styles.table_sec}>
      <Box className={styles.table_top}>
        <FilterRow
          {...filterRowProps}
          FilterModalComponent={AllPurchasedFilterModal}
          filterModalProps={{
            hideBottom: true,
          }}
        />
      </Box>
      <Box className={styles.table_main}>
        <TableContainer component={Paper}>
          <Table className={styles1.allPurchasedTable}>
            <TableHead>
              <TableRow>
                <TableCell className={styles1.vsid}>VSID</TableCell>
                {/* <TableCell>Acquisitor</TableCell> */}
                <TableCell className={styles1.buyer}>Buyer</TableCell>
                <TableCell className={styles1.thumb}>Thumbnail</TableCell>
                <TableCell className={styles1.title}>Title</TableCell>
                <TableCell className={styles1.owner}>Owner Name</TableCell>
                <TableCell className={styles1.email}>Email Address</TableCell>
                <TableCell className={styles1.purchase}>
                  Purchase Date
                </TableCell>
                {!hideApprovedTab ? (
                  <TableCell className={styles1.approve}>
                    {approvedTabName || "Approved by"}
                  </TableCell>
                ) : null}
                {/* pathname: '/release-video' */}
                <TableCell className={styles1.release}>
                  {pathname === "/release-video" ? "Removal Reason" : null}
                </TableCell>
                <TableCell className={styles1.view}>View</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.VSID}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell>
                    <Box className={styles.vsid_code}>
                      <img src={assest.infoicon} width={3} height={18} alt="" />{" "}
                      <p>
                        {row.VSID}
                         {/* <span className={styles.vsid_circ}></span> */}
                      </p>
                    </Box>
                  </TableCell>
                  <TableCell>{row.Buyer}</TableCell>
                  <TableCell>
                    <figure className={styles.thumb_img}>
                      {row.Thumbnail}
                    </figure>
                  </TableCell>
                  <TableCell>{row.Title}</TableCell>
                  <TableCell>{row.Owner}</TableCell>
                  <TableCell>{row.Email}</TableCell>
                  <TableCell>{row.Purchase}</TableCell>
                  {!hideApprovedTab ? (
                    <TableCell>
                      <Box className={styles1.approveBox}>{row.Approved}</Box>
                    </TableCell>
                  ) : null}
                  <TableCell>
                    {pathname === "/release-video" ? (
                      <>
                        <Button onClick={handleClickOpen}>
                          Copyright Dispute
                        </Button>
                      </>
                    ) : null}
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/video/${row.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Box className={styles.table_view}>
                        <img
                          src={assest.tableview}
                          width={16}
                          height={16}
                          alt=""
                        />
                      </Box>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          lastpage={undefined}
          onClick={undefined}
          sendDataToParent={undefined}
        />
      </Box>

      <Dialog className="filterModal" onClose={handleClose} open={open}>
        <DisplayRelease />
      </Dialog>
    </Box>
  );
}
